import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Document certifié — fichier avec sceau duotone */
export const FileBadgeIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Sceau menthe (badge en bas) */}
      <circle cx="8.5" cy="17.5" r="3.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M7 17.5h3l-1.5 3.5 3-2 3 2-1.5-3.5h3"
        stroke="var(--equiply-icon-bg)" strokeWidth="1.25" strokeLinejoin="round" fill="var(--equiply-icon-bg)"
      />
      {/* Document */}
      <path
        d="M5 3.5h9l5 5v10.5a1.5 1.5 0 0 1-1.5 1.5h-4"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path
        d="M5 3.5A1.5 1.5 0 0 0 3.5 5v9.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Coin replié */}
      <path
        d="M14 3.5V7a1.5 1.5 0 0 0 1.5 1.5H19"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Sceau contour */}
      <circle cx="8.5" cy="17.5" r="3.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
FileBadgeIcon.displayName = "FileBadgeIcon";
